function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#EBB300",
  strokeWidth: 1.571,
  cx: 11,
  cy: 11,
  r: 7.857
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EBB300",
  cx: 11,
  cy: 3.143,
  r: 3.143
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EBB300",
  cx: 18.857,
  cy: 11,
  r: 3.143
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EBB300",
  cx: 3.143,
  cy: 11,
  r: 3.143
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EBB300",
  cx: 11,
  cy: 18.857,
  r: 3.143
}));

function SvgTerminalOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTerminalOn;